import { render } from "./TaskTableRow.vue?vue&type=template&id=1ea84a4e&scoped=true"
import script from "./TaskTableRow.vue?vue&type=script&lang=js"
export * from "./TaskTableRow.vue?vue&type=script&lang=js"

import "./TaskTableRow.vue?vue&type=style&index=0&id=1ea84a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea84a4e"]])

export default __exports__